export default __webpack_public_path__ + "static/media/ARInvoiceImg.044067ce.svg";